// src/hooks/useArticles.ts

import { useCallback, useEffect, useState } from 'react'
import {
  fetchArticles,
  type ArticleListParams,
  type ArticleListResponse,
} from '../services/articleService'

interface UseArticlesState {
  data: ArticleListResponse | null
  loading: boolean
  error: string | null
}

interface UseArticlesReturn extends UseArticlesState {
  refetch: () => void
}

/**
 * Hook custom pour récupérer la liste des articles.
 * `data` est directement un Article[] (pas d'enveloppe).
 */
export function useArticles(params: ArticleListParams = {}): UseArticlesReturn {
  const [state, setState] = useState<UseArticlesState>({
    data: null,
    loading: true,
    error: null,
  })

  const paramsKey = JSON.stringify(params)

  const load = useCallback(async () => {
    console.debug('[useArticles] chargement démarré')
    setState((prev) => ({ ...prev, loading: true, error: null }))
    try {
      const data = await fetchArticles(params)
      console.debug('[useArticles] chargement réussi', { count: data.length })
      setState({ data, loading: false, error: null })
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Erreur inconnue.'
      console.error('[useArticles] chargement échoué', { error: message })
      setState({ data: null, loading: false, error: message })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsKey])

  useEffect(() => { load() }, [load])

  return { ...state, refetch: load }
}